import { createPortal } from 'react-dom';
import { CatCard } from '@blocks-react/components/Card';
import { CatLoadingIndicator } from '@blocks-react/components/LoadingIndicator';
import styles from './LoaderWithOverlay.module.scss';

const LoaderWithOverlay = ({
  message,
  cardClassName,
  messageClassName
}: {
  message: string;
  cardClassName?: string;
  messageClassName?: string;
}) => {
  const bodyElement = document.getElementsByTagName('body')[0];

  const Component = () => {
    return (
      <div
        className={`d-flex justify-content-center align-items-center h-100 w-100 position-fixed top-0 left-0 ${styles['overlay']}`}
      >
        <CatCard>
          <div
            className={`d-flex ${styles['loader-container']} ${cardClassName}`}
          >
            <CatLoadingIndicator data-testid="cat-loading-icon" />
            {message ? <div className={messageClassName}>{message}</div> : null}
          </div>
        </CatCard>
      </div>
    );
  };

  return createPortal(<Component />, bodyElement);
};

export default LoaderWithOverlay;
